<div class="row ss-top-menu">
  <div class="col-md-4">
    <span class="ss-text-dark">Dashboard </span>
  </div>
  <div class="col-md-8">
    <div class="dropdown show addCursor" *ngIf="brokerDetails && brokerDetails.user.kyc_approved == true">
      <a class="actionBtn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Action
      </a>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
        <a class="dropdown-item" data-toggle="modal" data-target="#addNewLeadModal">Add Lead</a>
        <!-- <a class="dropdown-item" data-toggle="modal" data-target="#uploadExcelModal">Upload Excel</a> -->
        <a class="dropdown-item" data-toggle="modal" data-target="#addContactModal">Add Contacts</a>
      </div>
    </div>
    <button class="bt-boq btn btn-pink mr-2 p-2 pull-right" type="button" data-toggle="modal" data-target="#inviteChampionModal" *ngIf = "is_champion=='true'" (click)="referralinvitechampions.getChampionList()">Invite Level 2 & Level 3 User</button>
  </div>
</div>

<div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>

<div class="row body_height pt-3 mt-5" *ngIf="brokerDetails && brokerDetails.user.kyc_approved == true">
  <div class="col-lg-3 my-3">
    <div class="card py-2 px-2 addCursor" data-toggle="modal" data-target="#addNewLeadModal">
        <h6 class="text-center my-4" >Add Lead</h6>
    </div>
  </div>
  <!-- <div class="col-lg-3 my-3">
    <div class="card py-2 px-2 addCursor" data-toggle="modal" data-target="#uploadExcelModal">
      <h6 class="text-center my-4" >Upload Excel</h6>
    </div>
  </div> -->
  <div class="col-lg-3 my-3">
    <div class="card py-2 px-2 addCursor" data-toggle="modal" data-target="#addContactModal">
        <h6 class="text-center my-4" >Add Contacts</h6>
    </div>
  </div>
  <div class="col-lg-3 my-3">
      <!-- <div class="card py-2 px-2 addCursor" data-toggle="modal" data-target="#inviteChampionModal" (click)="getChampionList()">
          <h6 class="text-center my-4" >Invite Champion</h6>
      </div> -->
    </div>
</div>

<div class="row body_height justify-content-center" *ngIf="brokerDetails && brokerDetails.user.kyc_approved == false">
  <div class="col-11 pt-5">
  	<form class="viewProfileForm" [formGroup]="editBrokerInformation" (ngSubmit)="updateBrokerInfoFormSubmit(editBrokerInformation.value);" >
      <div class="row">
        <div class="col-sm-10 col-lg-6">
  		    <div class="form-group">
            <label>Name*</label>
          	<input type="text" class="form-control" value="{{brokerDetails.user.name}}"  id="name" required name="name" formControlName="name">
          	<div *ngIf="editBrokerInformation.controls['name'].errors && !editBrokerInformation.controls['name'].pristine" class="text-danger">
              	<div [hidden]="!editBrokerInformation.controls['name'].errors.required">Name is required.</div>
          	</div>
          </div>
        </div>
        <div class="col-sm-10 col-lg-6">
          <div class="form-group">
          	<label>Email</label>
          	<input type="email" class="form-control" value="{{brokerDetails.user.email}}"  id="email" name="email" formControlName="email" readonly>
          </div>
        </div>
        <div class="col-sm-10 col-lg-6">
          <div class="form-group">
          	<label>Contact</label>
          	<input type="text" class="form-control" value="{{brokerDetails.user.contact}}"  id="contact" name="contact" formControlName="contact">
          </div>
        </div>
        <div class="col-sm-10 col-lg-6">
          <div class="form-group">
          	<label>Pincode</label>
          	<input type="text" class="form-control" value="{{brokerDetails.user.pincode}}"  id="pincode" name="pincode" formControlName="pincode">
          </div>
        </div>
        <div class="col-sm-10 col-lg-6">
          <div class="form-group">
          	<label>GST</label>
          	<input type="text" class="form-control" value="{{brokerDetails.user.gst_number}}"  id="gst_number" name="gst_number" formControlName="gst_number">
          </div>
        </div>
        <div class="col-sm-10 col-lg-6">
          <div class="form-group">
          	<label>Pan</label>
          	<input type="text" class="form-control" value="{{brokerDetails.user.pan}}"  id="pan" name="pan" formControlName="pan">
          </div>
        </div>
        <div class="form-group">
            <label>Address Proof</label>
            <input type="file" class="mb-3 mt-3" (change)="addressProofChange($event)" name="address_proof" ngModel #address_proof="ngModel" [ngModelOptions]="{standalone: true}">
            <a href="{{brokerDetails.user.address_proof}}" download *ngIf="brokerDetails.user.address_proof !='/images/original/missing.png'">Download uploaded adddress proof</a>
        </div>
        <div class="col-10">
          <button class="button mt-3" type="submit"  [disabled]="!editBrokerInformation.valid">Update</button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Add lead modal -->
<div class="modal fade customModal" id="addNewLeadModal" tabindex="-1" role="dialog" aria-labelledby="addNewLeadModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <form (ngSubmit)="addLeadFormSubmit(addLeadForm.value);" [formGroup]="addLeadForm" class="form-horizontal" enctype="multipart/form-data">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="exampleModalLabel">Add Lead</h5>
        <button type="button" class="close addCursor" data-dismiss="modal" aria-label="Close" (click)=" closeAddLeadModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label class="text-left">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" name="name" placeholder="Enter Lead Name" formControlName="name" required>
              <div *ngIf="addLeadForm.controls['name'].errors && !addLeadForm.controls['name'].pristine" class="text-danger">
                <div [hidden]="!addLeadForm.controls['name'].errors.required" class="text-font14">Name is required.</div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label class="text-left">Contact <span class="text-danger">*</span></label>
              <input type="number" class="form-control" name="contact" placeholder="Enter Lead Contact" formControlName="contact" required min="0" (keydown)="numberCheck($event)">
              <div *ngIf="addLeadForm.controls['contact'].errors && !addLeadForm.controls['contact'].pristine" class="text-danger">
                <div [hidden]="!addLeadForm.controls['contact'].errors.required" class="text-font14">Contact is required.</div>
                <div [hidden]=" addLeadForm.controls['contact'].errors.valid" class="text-font14">Contact is not valid(10 digits only).</div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 mt-2">
            <div class="form-group">
              <label class="text-left">Pincode</label>
              <input type="number" class="form-control" name="pincode" placeholder="Enter Lead Pincode" formControlName="pincode" min="0" (keydown)="numberCheck($event)">
            </div>
          </div>
          <div class="col-sm-12 col-md-6 mt-2">
            <div class="form-group">
              <label class="text-left">Email</label>
              <input type="text" class="form-control" name="email" placeholder="Enter Lead Email" formControlName="email">
              <div *ngIf="addLeadForm.controls['email'].errors && !addLeadForm.controls['email'].pristine" class="text-danger">                              
                <div [hidden]="addLeadForm.controls['email'].valid" class="text-font14">Enter valid email.</div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-5 text-right">
            <div class="mt-3">
            <button type="submit" class="rk-interalBtnColor addCursor" [disabled]="!addLeadForm.valid">Add</button>
            <button class="rk-btnCancel addCursor ml-3" data-dismiss="modal" (click)="closeAddLeadModal()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </form>
  </div>
</div>

<!--Excel moadl-->
<div class="modal fade" id="uploadExcelModal" tabindex="-1" role="dialog" aria-labelledby="uploadExcelModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <form (ngSubmit)="submitExcelUpload(); uploadExcelForm.reset()" #uploadExcelForm="ngForm" class="form-horizontal" enctype="multipart/form-data">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle">Upload Lead Excel</h5>
        <button type="button" class="close addCursor" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="form-group col-sm-12">
            <a href="https://s3.amazonaws.com/arrivae-assets/lead/Lead_sample_file.xlsx" class="addCursor pull-right" download style="text-decoration: none;">Download sample excel file</a>
          </div>
          <div class="form-group col-sm-12">
            <input class="form-control" type="file" (change)="onChange($event)" name="attachment_file" ngModel #attachment_file="ngModel">
          </div>
          <p id="extErrorMsg" class="text-danger d-none col-sm-10">Check File extension (File should be in xls or xlsx format).</p>
          <p class="col-sm-12 text-font14">Note* - only .xlsx or .xls files are allowed.  </p>
          <hr class="my-3">
          <div class="text-right col-sm-12">
            <button type="submit" class="rk-interalBtnColor addCursor" [disabled]="basefile==undefined">Upload</button>
            <button class="ml-2 rk-btnCancel  addCursor" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    </form>
  </div>
</div>

<!--Add contacts modal-->
<div class="modal fade" id="addContactModal" tabindex="-1" role="dialog" aria-labelledby="uploadExcelModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form (ngSubmit)="onLeadContactSubmit(addLeadContactForm.value);" [formGroup]="addLeadContactForm" class="form-horizontal" enctype="multipart/form-data">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Contact</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
            <div class="form-group col-sm-5">
              <input class="form-control" type="number" name="leadcontact" placeholder="Enter Mobile No" formControlName="phone_number" min="0" (keydown)="numberCheck($event)">
              <div *ngIf="addLeadContactForm.controls['phone_number'].errors && !addLeadContactForm.controls['phone_number'].pristine" class="text-danger">
                <div [hidden]="!addLeadContactForm.controls['phone_number'].errors.required">Mobile No. is required.</div>
              </div>
            </div>
            <div class="text-right col-sm-5">
              <button type="submit" class="button_emi" [disabled]="!addLeadContactForm.valid">Submit</button>
              <button class="ml-2 cancel" data-dismiss="modal">Cancel</button>
            </div>
        </div>
      </div>
    </div>
    </form>
  </div>
</div>


<!-- Invite Champion Modal -->
<div class="modal fade customModal" id="inviteChampionModal" tabindex="-1" role="dialog" aria-labelledby="inviteChampionModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title modalTitle" id="inviteChampionModalLabel">User Details</h5>
      </div>

      <div class="modal-body">
        <app-invite-champions #customerheadinvitechampions></app-invite-champions>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/broker-dashboard/broker-dashboard.component.html